import DataTable from '../../../../../components/Datatable';
import Loading from '../../../../../components/Loading';
import { COLUMNS, EXTRA_COLUMNS } from './keys';
import { getSortKeys, setAdditionalStyles } from '../../../../../helpers/table';
import { query } from './query';
import { Component } from 'react';
import { v4 as uuid } from 'uuid';
import { withTranslation } from 'react-i18next';
import AdditionalBox from './additionalBox';

class Prompts extends Component {
    constructor() {
        super();

        this.getData = this.getData.bind(this);
        this.forceRun = this.forceRun.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onRemoveAllSelected = this.onRemoveAllSelected.bind(this);
        this.collectData = this.collectData.bind(this);
        this.handleMoodeChange = this.handleMoodeChange.bind(this);
        this.handleSelectStatus = this.handleSelectStatus.bind(this);

        const isDark = JSON.parse(localStorage.getItem('dark-mode'));

        this.state = {
            data: [],
            loading: true,
            totalMentions: 1,
            selectedItems: [],
            removeAllSelected: false,
            isDark: !!isDark,
            selectedStatus: 'all',
        };
    }

    componentDidMount() {
        document.addEventListener('changeMoodEvent', this.handleMoodeChange);
    }

    componentWillUnmount() {
        document.removeEventListener('changeMoodEvent', this.handleMoodeChange);
    }

    handleSelectStatus(value) {
        if (value === 'all') {
            this.setState({ selectedStatus: value, sortedData: this.state.data });
            return;
        }
        const data = this.state.data.filter((item) => {
            const prompt = this.props.project.prompts?.find(
                (prompt) => prompt.prompt === item.prompt,
            );
            return prompt?.status === value;
        });
        this.setState({ selectedStatus: value, sortedData: data });
    }

    handleMoodeChange() {
        const isDark = JSON.parse(localStorage.getItem('dark-mode'));
        this.setState({ isDark });
    }

    onSelect(action, state) {
        if (action.type === 'REMOVE_ALL') return this.setState({ selectedItems: [] });
        this.setState({ selectedItems: state.ids, removeAllSelected: false });
    }

    onRemoveAllSelected(bool) {
        this.setState({
            removeAllSelected: bool,
            selectedItems: [],
        });
    }

    async getData({ force = false, alreadyInQueue = false }) {
        try {
            this.query = query({
                prompt_uids: this.props.prompt_uids,
                base_domain: this.props.project?.own_domain,
                brand: this.props.project?.own_product_name,
            });
            this.setState({ loading: true });

            this.query.bind(this.setState.bind(this));
            const results = await this.query.update({ force, alreadyInQueue });
            const data = results?.map((x) => ({ id: uuid(), ...x }));
            this.setState({
                data,
                sortedData: data,
                loading: false,
            });
        } catch (err) {
            console.log(err);
        }
    }

    forceRun() {
        this.getData({ force: true, alreadyInQueue: true });
    }

    async componentDidUpdate(prevProps) {
        if (
            !this.props.globalLoading &&
            this.props.globalLoading !== prevProps.globalLoading &&
            !this.props.prompt_uids?.length
        ) {
            this.setState({ data: [], loading: false });
        }
        if (
            JSON.stringify(prevProps.prompt_uids) !== JSON.stringify(this.props.prompt_uids) ||
            JSON.stringify(prevProps.platforms) !== JSON.stringify(this.props.platforms)
        ) {
            this.getData({});
        }

        if (this.props.updateAll !== prevProps.updateAll) {
            this.forceRun();
        }
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.prompt?.toLowerCase().includes(search.toLowerCase()));
    }

    collectData() {
        const { sortedData: data } = this.state;
        if (this.props.project && data?.length) {
            const updatedData = data.map((item) => {
                const prompt = this.props.project.prompts?.find(
                    (prompt) => prompt.prompt === item.prompt,
                );
                if (prompt) {
                    return {
                        ...item,
                        id: prompt.id,
                        tags: prompt.tags,
                        status: prompt.status,
                    };
                }

                return item;
            });
            return updatedData;
        }

        return data;
    }

    render() {
        const { t } = this.props;
        const columns = COLUMNS(t, this.state.isDark, this.state.selectedItems);

        const additionalBox = () => (
            <AdditionalBox
                t={t}
                onRemoveAllSelected={this.onRemoveAllSelected}
                selectedItems={this.state.selectedItems}
                getPrompts={this.props.getProjectData}
                selectedStatus={this.state.selectedStatus}
                handleSelectStatus={this.handleSelectStatus}
            />
        );
        const data = this.collectData();

        return (
            <div className="card table-main rounded-main ">
                {this.state.loading || this.props.loadingProjectForChildren ? (
                    <Loading padding={10} />
                ) : (
                    <DataTable
                        nodes={data ?? []}
                        sortFns={getSortKeys(columns)}
                        searchFunction={this.searchFunction}
                        COLUMNS={columns}
                        header={'Own Performance By Prompt'}
                        additionalBox={additionalBox}
                        customEmptyMessage={t('global.no_data')}
                        forceRun={this.forceRun}
                        additionalStyles={setAdditionalStyles(columns, true)}
                        EXTRA_HEADER={EXTRA_COLUMNS(t, this.state.isDark)}
                        headerHasCustomStyles
                        hasSelect={true}
                        onSelect={this.onSelect}
                        removeAllSelected={this.state.removeAllSelected}
                    />
                )}
            </div>
        );
    }
}

export default withTranslation()(Prompts);
